import {
    Button,
    CardContent,
    Grid,
    TextField,
    Typography,
    Divider,
    Table,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import Autocomplete from "@mui/material/Autocomplete";
  import { toast } from "react-toastify";
  import dayjs from "dayjs";
  import ToastApp from "../../../ToastApp";
  import { useTranslation } from "react-i18next";
  import api from "../../../utils/Url";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
// import { useFormik } from "formik";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";


  type Props = {};
  

  
  interface FileOption {
    value: number;
    fileName: string;
    fileNo?: string;
    synopsis: string;
    remark: string;
    totalPages: string;
    rfid: string;
    chackNo: string;
  }
  
  const FileMovementEdit = (props: Props) => {

    console.log("useLocation " + useLocation());
  const location = useLocation();
  console.log("location", location.state);
  let navigate = useNavigate();

  
    const { i18n, t } = useTranslation();
    const [memberOption, setMemberOption] = useState<any>("");
    const [antina, setAntina] = useState<any>(0);
  
    const [epcNumber, setEPCNumber] = useState<any>("");
    const [fileDetails, setFileDetails] = useState<any[]>([]);
    const [fileDetailsTableData, setFileDetailsTableData] = useState<any>([]);
    const [throughyby, setThroughby] = useState("");
    //FileDetails Tran section
    const [chakno, setChakNo] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileNo, setFileNo] = useState("");
    const [remark, setRemark] = useState("");
    const [rfid, setRFID] = useState("");
    const [synopsis, setSynopsis] = useState("");
    const [totalPages, setTotalPages] = useState("");
  
    const [isChecked, setIsChecked] = useState(false);
  
    const [LocationOption, setLocationOption] = useState<any>([
      { value: "-1", label: "Select To Location" },
    ]);


    interface FilmOptionType {
        label: string;
        value: string;
      }

    const [receiverName, setReceiverName] = useState("");
    const [senderName, setSenderName] = useState("");
    const [selectedLocationLabel, setSelectedLocationLabel] = useState('');
    const [fileIDs, setFileID] = useState("");
  
    const [senderOptions, setSenderOptions] = useState<any>([]);
    const [receiverOptions, setReceiverOptions] = useState<any>([]);
  
    const [isDefaultValueSet, setIsDefaultValueSet] = useState(false);
  
    const [filenames, setFileNames]=useState<FilmOptionType | null>(
        null
      );
    if (!isDefaultValueSet) {
      const defaultLocation = LocationOption.find(
        (option: any) => option.value === parseInt(synopsis)
      );
  
      if (defaultLocation) {
        setSelectedLocationLabel(defaultLocation.label);
        setIsDefaultValueSet(true);
      }
    }
  
  
  
  
    useEffect(() => {
        // setThroughby(location.state.throughBy);
      fetchMemberData();
      fetchRecevierMemberData();
      getFileDtailsData();
      getLocation();
      //getFileDtailsDatabyId(location.state.fileID);
    }, []);
  
    const getLocation = () => {
      const collectData = {
        id: -1,
      };
      api
        .post( `LocationItems/GetMappedLocation`, collectData)
        .then((res) => {
          const arr = res.data.data.map((item: any) => ({
            label: item.location,
            value: item.id,
          }));
          setLocationOption(arr);
        });
    };
  
  
    
  
    const getFileDtailsData = async () => {
      const collectData = {
        fileID: -1,
        fileType: -1,
        fileGroup: -1,
        fileCategory: -1,
        fileClass: -1,
        fileSubject: -1,
        show: true,
        exportOption: "",
      };
      const res = await api.post(
         `FileDetail/GetFileDetails`,
        collectData
      );
      const arr: any = [];
      
      for (let index = 0; index < res.data.data.length; index++) {
        arr.push({
          label: res.data.data[index]["fileName"],
          value: res.data.data[index]["fileID"],
        });
      }
      setFileDetails(arr);
    };
  
    
    const fetchMemberData = () => {
      const collectData = {
        useR_ID:"-1"
      };
      api
        .post( `USER/GetUSER`, collectData)
        .then((response) => {
          const arr = response.data.data.map((item: any) => ({
            label: item.firsT_NAME,
            value: item.useR_ID,
          }));
          setMemberOption(arr);
          setSenderOptions(arr);
          // setReceiverOptions(arr);
        });
    };
  
    let ID: any = localStorage.getItem("useR_ID")
    if (ID !== null) {
      ID = ID.replace(/\D/g, '');
      // console.log("useR_ID", parseInt(ID));
    } else {
      toast.error("User ID not Found");
    }
  
    const fetchRecevierMemberData = () => {
      const collectData = {
        useR_ID:(ID),
      };
      api
        .post( `USER/GetSelectedUSER`, collectData)
        .then((response) => {
          const arr = response.data.data.map((item: any) => ({
            label: item.firsT_NAME,
            value: item.useR_ID,
          }));
          setMemberOption(arr);
          setReceiverOptions(arr);
        });
    };
  
    const handleSenderChange = (event:any, newValue:any) => {
      const selectedId = newValue ? newValue?.value : '';
      setReceiverOptions(memberOption.filter((option:any) => option?.value !== selectedId));
      setSenderName(selectedId);
      formik.setFieldValue("sender", selectedId);
    };
  
    const handleReceiverChange = (event:any, newValue:any) => {
      const selectedId = newValue ? newValue?.value : '';
      setReceiverName(selectedId);
      formik.setFieldValue("receiver", selectedId);
      setSenderOptions(memberOption.filter((option:any) => option?.value !== selectedId));
    };
  

    const formik = useFormik({
        initialValues: {
            "hid": location.state.hid,
            "fileID": location.state.fileID || null,
            "fileNumber": location.state.fileNumber,
            "fileDate": "2024-04-29T08:23:40.077Z",
            "fromLocation": location.state.fromLocation || null,
            "toLocation": location.state.toLocation || null,
            "sender": location.state.sender || null,
            "receiver": location.state.receiver || null,
            "createdDate": "2024-04-29T08:23:40.077Z",
            "createdBy": "",
            "throughBy": location.state.throughBy,
            "transferDate": location.state.transferDate,
        },
        // validationSchema: validationSchema,
        onSubmit: async (values) => {
            // values.sender = senderName;
            // values.receiver = receiverName;
            // values.fileID = fileIDs;
            // values.fileNumber = fileNo;
            
            console.log("Values", values);

            const response = await api.post(
                `FileMovementHistory/AddUpdateFileMovementHistory`,
            values
        );
            if (response.data.isSuccess) {
              //setToaster(false);
              toast.success(response.data.mesg);
              navigate('/Library/UserFileMovement');
            } else {
             // setToaster(true);
              toast.error(response.data.mesg);
            }
    
        },
      });
      
      const back = useNavigate();
  

    return (
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "3vh",
          // border: ".5px solid #FF7722",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500,  }}
          >
            {t("text.EditFileMovement")}
          </Typography>
          <Grid item sm={4} xs={12} >
            <Typography style={{ marginTop: '-75px' }}>
              <Button type='submit' onClick={() => back(-1)} variant='contained' style={{  marginTop: '45px', backgroundColor: 'blue', width: 20 }}><ArrowBackSharpIcon /></Button>
            </Typography>
          </Grid>
          <Divider />
          <br /><br/>
  
          <form onSubmit={formik.handleSubmit} style={{marginTop:"5px"}}>
            <Grid item xs={12} sm={12} container spacing={2}>
              
  
              <Grid item xs={12} sm={12} container spacing={4}>
                <Grid item lg={3} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    fullWidth
                    size="small"
                    options={memberOption}
                    value={memberOption.find((opt:any)=>opt.value === formik.values.sender)|| null}
                     onChange={handleSenderChange}
                    renderInput={(params) => (
                      <TextField {...params} label={t("text.SelectSenderMember")} />
                    )}
                  />
                </Grid>
  
                <Grid item lg={3} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={receiverOptions}
                    value={receiverOptions.find((opt:any)=>opt.value === formik.values.receiver)|| null}
                    fullWidth
                    size="small"
                    onChange={handleReceiverChange}
                    renderInput={(params) => (
                      <TextField {...params} label={t("text.SelectReceiverMember")} />
                    )}
                  />
                </Grid>
  
  
               
                <Grid xs={12} lg={3} sm={3} item style={{ marginBottom: "10px" }}>
                  <Autocomplete
                    disablePortal
                    options={fileDetails}
                    fullWidth
                    size="small"
                    value={fileDetails?.find((opt: any) => opt.value === formik.values.fileID) || null}
                    onChange={(event, newValue: any) => {
                      if (newValue) {
                        console.log("Selected value:", newValue);
                        formik.setFieldValue("fileID", newValue?.value);
                        formik.setFieldValue("fileNumber", newValue?.label);
                      }
                    }}
                    renderInput={(params:any) => (
                      <TextField {...params} label={t("text.selectfiledetails")} />
                    )}
                  />
                </Grid>
  
                <Grid lg={3} sm={3} xs={12} item>
                  <TextField
                    label={
                      <span>
                        {t("text.ethroughyby")}
                      </span>
                    }
                    id="throughBy"
                    name="throughBy"
                    value={formik.values.throughBy}
                    placeholder={t("text.ethroughyby")}
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={formik.handleChange}
                  />
                </Grid>
  
                <Grid container item xs={12} >
                  <Button
                    fullWidth
                    type="submit"
                    style={{
                      backgroundColor: "#4990E2",
                      color: "white",
                      marginBottom: "10px",
                      marginRight: "10px",
                      marginLeft: "10px",
                      width: "47%"
                    }}
                    // onClick={(e) => handleSubmit()}
                  >
                   {t("text.update")}
                  </Button>
                  <Button
                    type="reset"
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginBottom: "10px",
                      width: "47%"
  
                    }}
                    onClick={formik.handleReset}
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>
  
                <br />
              </Grid>
            </Grid>
          </form>
        </CardContent>
        <ToastApp />
      </div>
    );
  };
  
  export default FileMovementEdit;